module.exports = __webpack_public_path__ + "public/media/marketeer-vector1.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/marketeer-vector1.png
// module id = ./images/services/marketeer-vector1.png
// module chunks = 0